// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"380":"relatorio","962":"home"}[chunkId] || chunkId) + "." + {"246":"b5ece490","380":"800e216e","962":"bafb3c52"}[chunkId] + ".js";
};